<template>
  <div id="app">
    <div class="content">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
    
    <app-footer></app-footer>
  </div>
</template>

<script>
import Footer from "./components/Footer.vue";
export default {
  components: {
    appFooter: Footer
  }
};
</script>